import React from 'react'
import { GridGenerator } from './'
import get from 'lodash/get'

import setGridProductMutation from './gql/setGridProduct'
import getCategory from 'sections/category/gql/getCategory'
import { useMutation, updateQuery } from 'components/graphql'
import HasParentCategory from './HasParentCategory'
import DragableProductList from './DragableProductList'
import { StyledCategoryGrid } from './StyledCategoryGrid'

const ProductGrid = ({ category, readOnly }) => {
	const [setGridProduct] = useMutation(setGridProductMutation)

	const handleDrop = (cellNum, product) => {
		setGridProduct({
			variables: {
				categoryId: category.id,
		    position: cellNum,
		    productId: product.id
			},
			optimisticResponse: {
				__typename: 'Mutation',
				cashAssist: {
					__typename: 'CA_Mutation',
					setGridProduct: {
						__typename: 'GridProduct',
						product: {
							__typename: 'Product',
							img: null,
							category: null,
							price: [],
							...product,
							id: -1
						},
						id: -1,
				    categoryId: category.id,
				    mod_ver: -1,
				    position: cellNum,
				    productId: product.id
					}
				}
			},
			update: updateQuery({
				query: getCategory,
				variables: { id: category.id }
			}, (draft, { mutationResult, readQuery, queryField }) => {
				const oldGridProducts = get(readQuery, 'gridProducts', [])
				draft[queryField].gridProducts = oldGridProducts.filter(({ position }) => position !== get(mutationResult, 'position'))
				draft[queryField].gridProducts.push(mutationResult)
			})
		})
	}
	const handleRemove = cellNum => {
		setGridProduct({
			variables: {
				categoryId: category.id,
	    	position: cellNum
			},
			optimisticResponse: {
				__typename: 'Mutation',
				cashAssist: {
					__typename: 'CA_Mutation',
					setGridProduct: {
						__typename: 'GridProduct',
						id: -1,
						mod_ver: -1,
				    categoryId: category.id,
				    position: cellNum,
				    productId: null,
				    product: null
					}
				}
			},
			update: updateQuery({
				query: getCategory,
				variables: { id: category.id }
			}, (draft, { mutationResult, readQuery, queryField }) => {
				const oldGridProducts = get(readQuery, 'gridProducts', [])
				draft[queryField].gridProducts = oldGridProducts.filter(({ position }) => position !== get(mutationResult, 'position'))
			})
		})
	}

	const { id: categoryId, dimensions, name, mod_ver, gridProducts = [] } = category
	const filteredGridProds = gridProducts.filter(item => item)
	const selectedProductIds = filteredGridProds.map(({ productId }) => productId)
	const hasParentCategory = !!category.categoryId

	if(hasParentCategory) {
		return <HasParentCategory categoryId={category.id} parentCategoryId={category.categoryId}/>
	}
	return(
		<StyledCategoryGrid>
			<GridGenerator
				key={mod_ver}
				readOnly={readOnly}
				data={filteredGridProds}
				onDrop={handleDrop}
				categoryName={name}
				onRemove={handleRemove}
				dimensions={dimensions}
			/>
			<DragableProductList
				categoryId={categoryId}
				selectedProductIds={selectedProductIds}
				disableDrag={readOnly}
			/>
		</StyledCategoryGrid>
	)
}

export default ProductGrid
